import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loginBackground from '../loginQrCode/loginBackground.svg';
import QrCode from '../../components/QrCode/QrCode';
import './IssuanceScreen.css';
import { CredentialUrls } from '../../dtos/credentials';
import { initOpenIdIssuance } from '../../services/vidcredentials';

interface InitOpenIdPresentationResponse {
  qrBase64: string;
  rawOpenid4vp: string;
}

export default function IssuanceScreen() {
  const [qrCode, setQrCode] = useState('');
  const navigate = useNavigate();
  const generateQr = async () => {
    const retryLocation = CredentialUrls.VALIDATE;
    const response = await
    initOpenIdIssuance('pre-auth');
    if (!!response && 'error' in response) {
      navigate('/validation-process/failure', { state: { retryLocation } });
      return;
    }
    const initOpenIdPresentationResponse:
    InitOpenIdPresentationResponse = response.data;
    setQrCode(initOpenIdPresentationResponse.qrBase64);
  };

  useEffect(() => {
    generateQr();
  }, []);

  return (
    <div className="login-screen">
      <img
        src="/genericBackground.svg"
        alt="genericBackground"
        style={{
          position: 'absolute', top: 0, left: 0, objectFit: 'cover', width: '100vw', height: '100vh', zIndex: -1,
        }}
      />
      {/* Left Panel */}
      <div className="left-panel">
        {/* Top */}
        <div className="left-panel-top">
          <img src="/logo.svg" alt="DigitalGov Logo" className="logo" />
        </div>

        {/* Bottom */}
        <div className="left-panel-bottom">
          <button type="button" className="back-button" onClick={() => navigate('/login')}>
            <img src="/goBack.svg" alt="Back Logo" />
            Back
          </button>
        </div>

        {/* Center */}
        <div className="left-panel-center">
          <div className="login-heading-content-qr">
            <img src="/verticalSeparator.svg" alt="verticalSeparator" className="separator-img" />
            <h2 className="heading">
              Open your Wallet
              <br />
              and scan QR code
            </h2>
          </div>
          <p className="subtext">
            Access is protected, present a
            <br />
            verifiable credential to confirm your identity.
          </p>
        </div>

      </div>

      <div className="right-panel" style={{ backgroundImage: `url(${loginBackground})` }}>
        <div className="overlay-card">
          <div className="qr-box">
            {!qrCode ? (
              <div className="action__loader-wrapper">
                <div className="loader" />
              </div>
            ) : (
              <QrCode base64img={qrCode} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
